import DateFnsUtils from '@date-io/date-fns';
import { Category, RenderPreviewProps, Status } from './types.ts';

const dateFns = new DateFnsUtils();

export const formatDateTime = (date: Date | null) => {
  if (!date) {
    return null;
  }
  return dateFns.format(date, 'yyyy-MM-dd HH:mm');
};

export function createMaintenanceDescription(
  status: string,
  instance: string,
  startDate: Date | null,
  endDate: Date | null,
  description: string,
) {
  let previewDescription = '';

  function getFormattedDate(date: Date) {
    return dateFns.format(date, 'dd-MM-yyyy HH:mm');
  }

  if (status === Status.Announcement) {
    previewDescription = `Impacted instance is ${instance} from ${
      startDate && getFormattedDate(startDate)
    } to ${endDate && getFormattedDate(endDate)}. ${description}`;
  }

  if (status === Status.Started) {
    previewDescription = `Maintenance has started for instance ${instance}. Estimated completion date is ${
      endDate && getFormattedDate(endDate)
    }. ${description}`;
  }

  if (status === Status.Completed) {
    previewDescription = `Maintenance has been completed for instance ${instance}. ${description}`;
  }
  return previewDescription;
}

export const createTitleAndDescription = ({
  category,
  name,
  status,
  title,
  authorName,
  description,
  instance,
  startDate,
  endDate,
}: RenderPreviewProps) => {
  switch (category) {
    case Category.Incident:
      return {
        notificationTitle: `Incident on: ${name} with status: ${status} - ${title} - sent by: ${authorName}`,
        notificationDescription: `Impacted instance is ${instance}. ${description}`,
      };

    case Category.SecurityIncident:
      return {
        notificationTitle: `Security-Incident on: ${name} with status: ${status} - ${title} - sent by: ${authorName}`,
        notificationDescription: `Impacted instance is ${instance}. ${description}`,
      };

    case Category.Maintenance: {
      const previewMaintenanceDescription = createMaintenanceDescription(
        status,
        instance,
        startDate,
        endDate,
        description,
      );
      return {
        notificationTitle: `Maintenance on: ${name} with status: ${status} - ${title} - sent by: ${authorName}`,
        notificationDescription: previewMaintenanceDescription,
      };
    }

    case Category.Update:
      return {
        notificationTitle: `Update on: ${name} - ${title} - sent by: ${authorName}`,
        notificationDescription: `New Release ${description}`,
      };

    default:
      return {
        notificationTitle: `${category} on: ${name} - sent by: ${authorName}`,
        notificationDescription: description,
      };
  }
};
